import React, { Dispatch, SetStateAction } from "react";
import { Button } from "@emisgroup/ui-button";
import { useTranslation } from "react-i18next";
import { ProgressSpinner } from "@emisgroup/ui-progress-indicator";
import { AsyncBoundary } from "../../../../common/AsyncBoundry/AsyncBoundry";
import { ReportTable } from "./ReportTable";
import ChevronLeft from "~icons/ic/outline-chevron-left";
import "./Style.scss";

interface ISearchReportViewProps {
  executionName: string;
  cohortExecutionId: string;
  onBack: () => void;
  setSwitchView: Dispatch<SetStateAction<string>>;
}

export const SearchReportView: React.FC<ISearchReportViewProps> = ({
  executionName, cohortExecutionId, onBack, setSwitchView
}) => {
  const { t: translate } = useTranslation();

  return (
    <div className="search-report">
      <h5 className="search-report__execution-name">{executionName}</h5>

      <div className="search-report__header">
        <Button onClick={(): void => { onBack(); }} data-testid="backButton">
          <ChevronLeft title="back" />
        </Button>

        <h5 className="search-report__title">{translate("ResultDetails.SearchReport.Title")}</h5>
      </div>

      <AsyncBoundary
        key={cohortExecutionId}
        suspenseFallback={
          <div className="search-report__spinner-container">
            <ProgressSpinner delay={100} text={translate("ResultDetails.SearchReport.FetchingReport")} />
          </div>
        }
      >
        <p className="search-report__select-search">{translate("ResultDetails.SearchReport.SelectSearch")}</p>

        <ReportTable
          className="search-report__table"
          cohortExecutionId={cohortExecutionId}
          setSwitchView={setSwitchView}
        />
      </AsyncBoundary>
    </div>
  );
};
